



import { Vue } from "../../constants/constants";
import { staticContent } from '../../localisation/detect-lang'
export default Vue.component("address-book", {
  props: [
    "getCurrentLocation",
    "getAllAddresses",
    "getZonePolygon"
  ],
  data () {
    return {
      msg: "Message",
      staticContent
    };
  },
  mounted () {
  //  this.updatePinAddress('map1');
    this.getAllAddresses();
    if (window.location.hash === "#address-book-tab") {
      this.$root.tabsHandler("settings-tabs-nav", "change-address-book-btn");
    }
  },
  updated () {
  
  }
});
